import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';

import { LpBreadcrumbs } from './LpBreadcrumbs';
import { ViewToggle } from './ViewToggle';

export const LearningPathsSectionHeader = ({
  title,
  subtitle,
}: {
  title: string;
  subtitle?: string;
}) => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'));
  const isLg = useMediaQuery(theme.breakpoints.up('lg'));

  return (
    <Box sx={{ mb: 3 }}>
      {isLg && <LpBreadcrumbs />}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
        }}>
        <Box>
          <Typography variant="h1">{title}</Typography>
          {!!subtitle && (
            <Typography variant="body3SemiBold" sx={{ color: 'text.light' }}>
              {subtitle}
            </Typography>
          )}
        </Box>
        {isMd && <ViewToggle />}
      </Box>
    </Box>
  );
};
